package com.example.socialmediaapp.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

// ============================================
// REQUEST / RESPONSE MODELS
// ============================================

@Serializable
data class LoginRequest(val email: String, val password: String)

@Serializable
data class RegisterRequest(val username: String, val email: String, val password: String)

@Serializable
data class LoginResponse(val token: String, val user: ApiUser)

@Serializable
data class RegisterResponse(val message: String = "", val userId: String = "")

@Serializable
data class ApiUser(
    val id: String,
    val username: String,
    val email: String = "",
    val bio: String? = null,
    @SerialName("avatar_url") val avatarUrl: String? = null
)

@Serializable
data class UpdateProfileRequest(val username: String, val bio: String? = null)

@Serializable
data class MessageResponse(val message: String = "", val error: String = "", val success: Boolean = false)

// ============================================
// AUTH REPOSITORY
// ============================================

class AuthRepository(private val api: ApiClient) {

    suspend fun login(email: String, password: String): Result<LoginResponse> = runCatching {
        api.post<LoginResponse>("/api/auth/login", LoginRequest(email, password))
    }

    suspend fun register(username: String, email: String, password: String): Result<RegisterResponse> = runCatching {
        api.post<RegisterResponse>("/api/auth/register", RegisterRequest(username, email, password))
    }

    suspend fun logout(): Result<MessageResponse> = runCatching {
        api.post<MessageResponse>("/api/auth/logout")
    }

    suspend fun getMe(): Result<ApiUser> = runCatching {
        api.get<ApiUser>("/api/users/me")
    }

    suspend fun updateProfile(username: String, bio: String?): Result<ApiUser> = runCatching {
        api.patch<ApiUser>("/api/users/me", UpdateProfileRequest(username, bio))
    }

    suspend fun searchUsers(query: String): Result<List<ApiUser>> = runCatching {
        api.get<List<ApiUser>>("/api/users/search?q=${query.encodeURLPath()}")
    }
}

private fun String.encodeURLPath(): String = this.replace(" ", "%20")
